// Returns a link-safe URL for a user/imported website value, or null if it
// should not be rendered as a link (e.g. javascript: or other schemes).
export function safeUrl(value) {
  if (typeof value !== 'string') return null;
  const v = value.trim();
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return v;
  // Bare host like "example.com/path": no scheme, no ':' before the first '/'
  const slash = v.indexOf('/');
  const head = slash === -1 ? v : v.slice(0, slash);
  if (head.includes(':')) return null;
  if (/^[\s/\\]/.test(v)) return null;
  return `https://${v}`;
}

export default safeUrl;
